import {Injectable} from '@angular/core';
import {SessionService} from '../../session-service/session.service';
import {BehaviorSubject} from 'rxjs';
import {API_URL} from '../../constants/apiurl-constants';

@Injectable({providedIn: 'root'})
export class EditExpenseSurveyService {
expenseSurveyDetails: any;

constructor(private _sessionService: SessionService) {}



setExpenseSurveyDetails(surveyData: any) {
    if (surveyData) {
      this.expenseSurveyDetails = surveyData;
    }
  }
  getExpenseSurveyDetails() {
    return this.expenseSurveyDetails;
  }
}